const emailConfig = {
  addTitle: 'Add Sender',
  editTitle: 'Edit Sender',
  addButton: 'Add Email',
  dialogDesc:
    'Keep SMTP for standard mailboxes. For Gmail, go to the top-right profile center and bind Gmail there.',
  subtitle:
    'Enter the email first to auto-detect the provider. Common mailboxes stay simple, while custom domains expand advanced SMTP fields automatically.',
  heroTitle: 'Connect sender',
  heroDesc:
    'This page only shows connected mailboxes. Use the top-right button to add a new one or keep editing an existing one.',
  pageStepBind: 'Bind mailbox',
  pageStepTemplate: 'Add email template',
  heroStepDetect: 'Enter email',
  heroStepAuth: 'Complete auth',
  heroStepDone: 'Save and use',
  provider: 'Email Provider',
  providerPlaceholder: 'Select a provider to auto-fill settings',
  providerDetected: 'Detected automatically',
  providerHintIdle:
    'Enter an email address to auto-detect common providers and fill the recommended SMTP settings.',
  providerManual: 'You can still switch manually',
  providerUnknown: 'Provider not recognized. Please choose one manually.',
  providerUnknownAuto:
    'Common provider not recognized. Advanced SMTP options have been expanded for manual setup.',
  recommendedProviders: 'Popular providers',
  advancedTitle: 'Advanced options',
  advancedDesc:
    'If you use a custom domain mailbox or company mailbox, you can fill SMTP settings manually.',
  advancedShow: 'Show advanced options',
  advancedHide: 'Hide advanced options',
  smtpHost: 'SMTP Host',
  smtpHostPlaceholder: 'e.g. smtp.your-company.com',
  smtpPort: 'Port',
  smtpUsername: 'SMTP Username',
  smtpUsernamePlaceholder: 'Defaults to the email address, change only if needed',
  smtpSecurity: 'Encryption',
  smtpSecuritySSL: 'SSL / TLS',
  smtpSecuritySTARTTLS: 'STARTTLS / Upgrade from plain',
  smtpHostRequired: 'SMTP host is required',
  smtpPortRequired: 'SMTP port is required',
  smtpUsernameRequired: 'SMTP username is required',
  email: 'Email',
  emailPlaceholder: 'Enter your email address',
  nickname: 'Sender name',
  nicknamePlaceholder: 'Enter the sender name, for example: Clement Hu',
  nicknameHelper: 'Recipients will see this name as the sender display name.',
  nicknameRequired: 'Sender name is required',
  nicknameExampleButton: 'Example',
  nicknameExampleAlt: 'Sender name example',
  smtpAuthCode: 'Password',
  smtpAuthCodePlaceholder: 'Enter your mailbox password',
  authGuideTitle: 'Setup guide',
  authGuideDefault:
    'Enter the SMTP password for the mailbox, or the SMTP authorization code provided by the mail service.',
  authGuideDetected:
    'The provider has been detected from your email address. Confirm it, then enter the password.',
  authGuideQQ:
    'QQ Mail requires SMTP to be enabled first, then generate a separate authorization code.',
  qqGuideTitle: 'QQ Mail SMTP Guide',
  qqGuideDesc:
    'QQ Mail requires SMTP service to be enabled in mailbox settings first. Then generate an authorization code and fill it into the password field below.',
  qqGuideOpenAction: 'Open QQ Mail',
  qqGuideStep1: 'Open the QQ Mail website at https://mail.qq.com first.',
  qqGuideStep2: 'Click “Settings” in the top-right corner.',
  qqGuideStep3: 'Open “Account & Security” from the lower-left area.',
  qqGuideStep4: 'Go to “Security settings”.',
  qqGuideStep5: 'Enable the SMTP service.',
  qqGuideStep6:
    'Generate the authorization code, then paste it into the password input below.',
  authGuide163: '163 / 126 Mail requires client authorization password before setup.',
  authGuideAliyun:
    'Aliyun Mail usually requires SMTP to be enabled in admin settings and an authorization code or app password.',
  authGuideGmail:
    'For Gmail, one-click authorization is recommended. If you already have a Gmail app authorization code, you can also fill it in and continue.',
  gmailBindHint:
    'Gmail detected. You can authorize Gmail sending with one click, or enter a Gmail authorization code to continue.',
  gmailAppPasswordLabel: 'Google App Password',
  gmailAppPasswordPlaceholder: 'Enter your Google app password',
  gmailAuthorizeButton: 'Authorize Gmail Sending',
  gmailAuthorizeCardTitle: 'One-click authorization',
  gmailAuthorizeCardDesc:
    'This opens the Google authorization window, saves the mailbox to the backend automatically, and closes the current dialog after success.',
  gmailAuthorizePreparing:
    'Gmail authorization is being prepared. Once backend APIs are ready, this will jump to authorization directly.',
  gmailAuthorizeOnlyForGmail: 'One-click authorization is only available for Gmail addresses.',
  gmailConnectorMissing:
    'Google connector is missing. Please ask an admin to check environment variables.',
  gmailAuthorizePopupBlocked:
    'The browser blocked the authorization popup. Please allow popups and try again.',
  gmailAuthorizePopupOpened:
    'Gmail authorization window opened. Please finish authorization in the popup.',
  gmailAuthorizeRequired:
    'Gmail uses one-click authorization by default. Open advanced options if you want to enter an app password manually.',
  gmailAuthorizeFailed: 'Gmail authorization failed. Please try again.',
  gmailAuthorizeSaveFailed:
    'Gmail authorization succeeded, but saving the mailbox config failed. Please return and try again.',
  gmailAuthorizeStateInvalid: 'Authorization state is invalid. Please start again.',
  gmailAuthorizeSessionExpired:
    'Authorization session expired. Please start Gmail authorization again.',
  gmailGuideTitle: 'Manual setup guide',
  gmailGuideStep1: 'Step 1: Complete Google 2-Step Verification (2FA) first.',
  gmailGuideStep1Action: 'Open 2FA setup',
  gmailGuideStep2: 'Step 2: Generate a Gmail app password and fill it into the field below.',
  gmailGuideStep2Action: 'Open app password page',
  authGuideOutlook:
    'Outlook / Microsoft 365 requires SMTP AUTH to be available and often an app password or allowed credential.',
  authGuideYahoo: 'Yahoo Mail requires an App Password instead of the normal account password.',
  authGuideICloud: 'iCloud Mail requires an app-specific password.',
  authGuideZoho: 'Zoho Mail works best with an app-specific password and SMTP enabled.',
  authGuideFeishu: 'Feishu Mail requires SMTP to be enabled and the matching authorization code.',
  authGuideOther:
    'If you are unsure where to find it, search your provider settings for SMTP or client authorization code.',
  authHintSecure: 'Recommended SMTP host, port and TLS settings will be applied automatically.',
  remark: 'Label',
  remarkPlaceholder: 'Required, e.g. Work email',
  remarkRequired: 'Label is required',
  remarkHelper: 'Use a short label so it is easy to pick the right sender later.',
  reset: 'Reset',
  save: 'Save',
  saveAndFinish: 'Save Sender',
  update: 'Update',
  saving: 'Saving...',
  saved: 'Sender added',
  updated: 'Sender updated',
  createFailedFriendly:
    'Failed to create the email configuration. Please check the mailbox and authorization settings, then try again.',
  updateFailedFriendly:
    'Failed to update the email configuration. Please check the mailbox and authorization settings, then try again.',
  selectProvider: 'Please select an email provider',
  listTitle: 'Senders',
  listSubtitle: 'Manage sender accounts',
  refresh: 'Refresh',
  noData: 'No senders yet. Please add an email first.',
  configCount: '{count} senders',
  providerCol: 'Provider',
  authMethodCol: 'Auth method',
  authMethodOAuth: 'Google OAuth',
  authMethodSmtp: 'SMTP credentials',
  emailRequired: 'Email address is required',
  authCodeRequired: 'Password is required',
  formSectionTitle: 'Quick setup',
  formSectionDesc:
    'Start with the email address. If auto-detection fails, advanced SMTP fields open automatically.',
  listSectionTitle: 'Senders',
  listSectionDesc:
    'Edit labels or replace the password. These senders are used for outreach emails.',
  emptyTitle: 'No sender connected yet',
  emptyDesc: 'Finish the form on the left and your sender will be ready to use.',
  secureNote: 'Preset SMTP settings applied',
  editMode: 'Editing sender',
  testSectionTitle: 'Send a test email',
  testSectionDesc:
    'A test email will be sent to the current mailbox using the form values, no save required.',
  testTargetEmail: 'Test recipient',
  testTargetEmailPlaceholder: 'Enter the mailbox that should receive the test email',
  testTargetEmailRequired: 'Test recipient is required',
  testTargetEmailInvalid: 'Enter a valid test recipient email',
  testSendButton: 'Send test email',
  testSent: 'Test email sent',
  testSendFailed: 'Failed to send test email',
  testSendCheckCredentials: 'Test email failed. Please check your email or password.',
  deleteConfirm: 'This action cannot be undone. Are you sure to continue?',
  deleteTitle: 'Delete Sender',
  alreadyConfigured: 'Sender loaded for editing',
  deleted: 'Deleted successfully',
  deleteFailed: 'Delete failed',
  loadConfigsFailed: 'Failed to load senders',
  loadConfigDetailFailed: 'Failed to load sender details',
  prefilledEditForm: 'Edit form populated',
}

export default emailConfig
